import { FormSelectOption } from '@/core/types/form-select-option';

export const FORM_DEFAULT_SELECT_OPTION: Readonly<FormSelectOption> = {
	value: 'DEFAULT',
	text: '-- Select --',
};
